import { IDDiagnosis } from 'models/DCK/basicInterface';

export const addNoShowDisabledField = (field: IDDiagnosis[]) => {
    return field.map((item) => {
        let newCounselDateTimeCount = 0;

        item.noShowInfo?.forEach((item) => {
            item.newCounselDateTime && newCounselDateTimeCount++;
        });

        return {
            ...item,
            noShowDisabled: item.noShowInfo?.length === newCounselDateTimeCount ? false : true,
        };
    });
};
